import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { SidePanelService } from '@app/shared/panels/services/side-panel.service';
import { FullPanelService } from '@app/shared/panels/services/full-panel.service';
import { MediumPanelService } from '@app/shared/panels/services/medium-panel.service';
import { ConfirmationBoxService } from '@app/shared/panels/services/confirmation-box.service';
import { ConfirmationModalService } from '@app/shared/panels/services/confirmation-modal.service';
import { WarningModalService } from '@app/shared/panels/services/warning-modal.service';
import { EmailModalService } from '@app/shared/panels/services/email-modal.service';
import { SmsModalService } from '@app/shared/panels/services/sms-modal.service';
import { SettingsSidePanelService } from '@app/shared/panels/settings-side-panel/settings-side-panel.service';
import { SettingsConfirmModalService } from '@app/shared/panels/settings-confirm-modal/settings-confirm-modal.service';
import { ToasterService } from '@app/shared/cs-toaster/toaster.service';
import { SettingsToasterService } from '@app/shared/cs-toaster/settings-toaster.service';
import { BreadcrumbsService } from '@app/shared/breadcrumbs/breadcrumbs.service';
import { StepperWizardHostService } from '@app/shared/stepper-wizard-layout/stepper-wizard-host.service';

@Injectable({ providedIn: 'root' })
export class MfeRegistryService {
    constructor(private injector: Injector) { }

    public publishServices() {
        const router = this.injector.get(Router);
        const ngZone = this.injector.get(NgZone);

        const registry = {
            sidePanel: this.injector.get(SidePanelService),
            fullPanel: this.injector.get(FullPanelService),
            mediumPanel: this.injector.get(MediumPanelService),
            confirmationBox: this.injector.get(ConfirmationBoxService),
            confirmationModal: this.injector.get(ConfirmationModalService),
            warningModal: this.injector.get(WarningModalService),
            emailModal: this.injector.get(EmailModalService),
            /** SMS compose widget — `show(config)` → `{ onSend, onClose }`, same contract as `emailModal`. */
            smsModal: this.injector.get(SmsModalService),
            settingsSidePanel: this.injector.get(SettingsSidePanelService),
            settingsConfirmModal: this.injector.get(SettingsConfirmModalService),
            toaster: this.injector.get(ToasterService),
            settingsToaster: this.injector.get(SettingsToasterService),
            breadcrumbs: this.injector.get(BreadcrumbsService),
            /** Wizard footer bridge for `cs-v20-stepper-wizard-layout` (Continue/Back + `canContinue`). */
            stepperWizardHost: this.injector.get(StepperWizardHostService),
            confirmationBoxHelper: this.injector.get(ConfirmationBoxService),
            /** SPA navigation for embedded MFEs (e.g. scheduler View job). */
            hostNavigation: {
                navigateByUrl: (path: string) => {
                    const url = String(path ?? '').trim();
                    if (!url) {
                        return;
                    }
                    const normalized = url.startsWith('/') ? url : `/${url}`;
                    ngZone.run(() => {
                        void router.navigateByUrl(normalized);
                    });
                },
            },
            isReady: true
        };

        // Force it onto the global window object explicitly
        (window as any)['MFE_REGISTRY'] = registry;

        // Double check immediately in the logs

        window.dispatchEvent(new CustomEvent('MFE_SERVICES_INITIALIZED'));
    }
}
